module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/eko-piknik/thumbs/5-337fcad1bfe318d6f6053b8914894fb4.webp";